import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWave } from "@/generated/models/ObjectSerializer";
import { MemesLeaderboardDrop } from "@/components/memes/drops/MemesLeaderboardDrop";
import { useWave } from "@/hooks/useWave";
import { DefaultWaveLeaderboardDrop } from "./DefaultWaveLeaderboardDrop";
interface WaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardDrop: React.FC<WaveLeaderboardDropProps> = t0 => {
  const $ = _c(7);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t1;
    if ($[0] !== drop || $[1] !== onDropClick) {
      t1 = <MemesLeaderboardDrop drop={drop} onDropClick={onDropClick} />;
      $[0] = drop;
      $[1] = onDropClick;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== drop || $[4] !== onDropClick || $[5] !== wave) {
    t1 = <DefaultWaveLeaderboardDrop drop={drop} wave={wave} onDropClick={onDropClick} />;
    $[3] = drop;
    $[4] = onDropClick;
    $[5] = wave;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};